import { render, staticRenderFns } from "./PawnShopOwner.vue?vue&type=template&id=6c0d6d3c&scoped=true&"
import script from "./PawnShopOwner.vue?vue&type=script&lang=js&"
export * from "./PawnShopOwner.vue?vue&type=script&lang=js&"
import style0 from "./PawnShopOwner.vue?vue&type=style&index=0&id=6c0d6d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d6d3c",
  null
  
)

export default component.exports